import { IsString, IsNotEmpty, IsOptional, IsArray } from 'class-validator';
import { Type } from 'class-transformer';

import { Substitute } from '.';

const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
  groups: ['form'],
};

type SubstituteType = 'permanent' | 'temporary';

export class CreateSubstituteFormDto {
  @IsString({
    ...NOT_EMPTY_OPTIONS,
  })
  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
  })
  typeOfSubstitute: SubstituteType;

  @Type(() => Substitute)
  @IsArray({
    groups: ['form'],
  })
  @IsOptional({
    groups: ['form'],
  })
  substitutions: Substitute[];

  @IsString({
    ...NOT_EMPTY_OPTIONS,
  })
  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
  })
  substituteId: string;

  @Type(() => String)
  @IsArray({
    ...NOT_EMPTY_OPTIONS,
  })
  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
  })
  eventTypes: string[];
}
